// extracted by mini-css-extract-plugin
module.exports = {"achievementWrapper":"styles_achievementWrapper__KNt3X","fade":"styles_fade__2I9YU"};